/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2ZvcmdldC1wYXNzd29yZC1lbWFpbC12ZXJpZmljYXRpb24vZm9yZ2V0LXBhc3N3b3JkLWVtYWlsLXZlcmlmaWNhdGlvbi5jb21wb25lbnQuc2NzcyJ9 */"];
export { styles as styles };
